import HeaderImg from "../components/HeaderImg";
import installation from "../assets/images/tools.png";
import repair from "../assets/images/technical-service.png";
import maintenance from "../assets/images/settings.png";
// import hero1 from "../assets/images/hero/1.jpeg";
import hero2 from "../assets/images/hero/2.jpeg";
import hero3 from "../assets/images/hero/3.jpeg";
// import hero4 from "../assets/images/hero/4.jpeg";
import hero5 from "../assets/images/hero/5.jpeg";
import hero6 from "../assets/images/hero/6.jpeg";
import hero7 from "../assets/images/hero/7.jpeg";
import { useEffect } from "react";

const Services = () => {
  const services = [
    {
      img: installation,
      title: "Medical and Surgical Equipment Installation",
      desc: "Professional installation of medical equipment to ensure optimal performance, safety, and compliance with industry standards. We handle setup, calibration, and user guidance.",
    },
    {
      img: repair,
      title: "Medical and Surgical Equipment Repair",
      desc: "Fast and reliable diagnostics and repair services to minimize downtime. Our technicians fix faults efficiently using quality parts and proven procedures.",
    },
    {
      img: maintenance,
      title: "Medical and Surgical Equipment Maintenance",
      desc: "Preventive and routine maintenance services to  ensure consistent performance and equipment in your facility",
    },
    {
      img: repair,
      title: "Medical and Surgical Equipment Fabrication/refurbishing",
      desc: "Custom fabrication and refurbishing services designed to restore, rebuild, and adapt medical and surgical equipment to meet your facility's specific needs and extend operational lifespan",
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="services">
      <HeaderImg title="Services" />
      <section className="services__section">
        <div className="services__grid">
          {services.map((service, index) => (
            <div key={index} className="services__item">
              <div className="services__item__img">
                <img src={service.img} alt={service.title} />
              </div>

              <div className="services__item__content">
                <h4 className="services__item__title">{service.title}</h4>
                <p>{service.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className="about__main__gallery">
        <img src={hero7} alt="" />
        <img src={hero2} alt="" />
        <img src={hero3} alt="" />
        <img src={hero6} alt="" />
        <img src={hero5} alt="" />
        {/* <img src={hero2} alt="" /> */}
        {/* <img src={hero3} alt="" />
                    <img src={hero1} alt="" /> */}
      </section>
    </div>
  );
};

export default Services;
